import React, { useState, useCallback, useRef, useEffect } from "react";
import styled from "styled-components";
import CloseIcon from "../icons/Close";
import { MediaCarousel, Gallery, StyledModal } from "./";
import CarouselImage from "./GalleryModal/CarouselImage";
import tw from "tailwind.macro";
import useBreakpoint from "utils/hooks/useBreakpoint";
import useOnClickOutside from "utils/hooks/useOnClickOutside";

const ModalContent = styled.div`
  ${tw`flex flex-col items-center justify-between bg-white p-0`}
  max-width: 1540px;
  max-height: 840px;
  width: 95vw;
  height: 95vh;
  min-width: 90vw;
  min-height: 90vh;
`;

const TitleContainer = styled.div`
  ${tw`text-mattammy-gray font-trade-gothic-20 flex justify-between items-center
  w-full h-auto py-5 px-4 uppercase border-b border-border-light-blue 
  `}
  font-size: 1.375rem;
`;
const ContentContainer = styled.div`
  ${tw`flex items-center w-full relative overflow-y-auto`}
  flex-grow: 1;
`;

const getSlides = (items) =>
  items.map((item) => (
    <CarouselImage
      key={item.itemId}
      src={item.imageUrl}
      alt={item.imageAlt}
      description={item.imageCaption}
      type={"image"}
      flag={item.flag}
    />
  ));

const ExteriorStylesModal = (props) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const [carouselPosition, setCarouselPosition] = useState(0);
  const slides = getSlides(props.styles);

  useEffect(() => {
    const index = props.styles.findIndex(
      (i) => i.itemId === props.style.itemId
    );
    setCarouselPosition(index);
  }, [props.style]);

  const handlePrevClick = useCallback(() => {
    if (carouselPosition > 0) {
      setCarouselPosition(carouselPosition - 1);
    } else {
      setCarouselPosition(slides.length - 1);
    }
  }, [carouselPosition]);

  const handleNextClick = useCallback(() => {
    if (carouselPosition < slides.length - 1) {
      setCarouselPosition(carouselPosition + 1);
    } else {
      setCarouselPosition(0);
    }
  }, [carouselPosition, slides.length]);

  const handleChange = useCallback(
    (value) => {
      if (value >= 0 && value < slides.length) {
        setCarouselPosition(value);
      }
    },
    [slides.length]
  );

  const modalRef = useRef();
  useOnClickOutside(modalRef, props.onClose);

  return (
    <StyledModal isOpen={props.isOpen}>
      <ModalContent>
        <div
          className="w-full h-full flex flex-col items-center"
          ref={modalRef}
          aria-modal="true"
          role="dialog"
        >
          <TitleContainer>
            <span className="mt-2">Exterior Styles</span>
            <button onClick={props.onClose}>
              <CloseIcon className="text-action-blue w-8 h-8" />
            </button>
          </TitleContainer>
          <ContentContainer>
            {["lg", "xl", "2xl"].includes(breakpoint) ? (
              <MediaCarousel
                value={carouselPosition}
                slides={slides}
                centered
                slidesPerPage={1}
                minDraggableOffset={10}
                onChange={handleChange}
                onPrevClick={handlePrevClick}
                onNextClick={handleNextClick}
              />
            ) : (
              <Gallery
                media={props.styles}
                columnsLg={1}
                columnsSm={1}
                className="p-4 h-full"
                breakpoint={breakpoint}
                mediaType="image"
              />
            )}
          </ContentContainer>
        </div>
      </ModalContent>
    </StyledModal>
  );
};

export default ExteriorStylesModal;
